const ToastTypeSuccess = "success";
const ToastTypeError = "error";
const ToastTypeInfo = "info";
const ToastTypeWarning = "warning";

export { 
  ToastTypeSuccess, ToastTypeError, ToastTypeInfo, ToastTypeWarning
}

